import React from 'react';
import styled from 'styled-components';
import Image from 'components/widgets/Image/Image';

const StyledLogo = styled(Image)`
  max-width: 80px;
  vertical-align: middle;
  max-height: 2.6rem;
`;
export const MerchantLogo = ({ className, src }: { className?: string; src: string }) => {
  return (
    <StyledLogo
      className={className}
      src={src || ''}
      dataTestId="logo"
      alt="company logo"
    />
  );
};
